/**
 * `PtDialogAutoMounterManager` - 管理 Vue 弹窗组件的注册、打开/关闭、以及属性更新等操作
 *
 * 在顶部总入口模版里需要加入
 *
 * <template v-for="name in ptDialogAutoMounterManager.loopForNames">
 *             <component v-if="ptDialogAutoMounterManager.attrMap[name].vIf"
 *                    :key="name"
 *                    :is="ptDialogAutoMounterManager.componentMap[name]"
 *                    v-on="ptDialogAutoMounterManager.attrMap[name].$listeners"
 *                    v-bind="ptDialogAutoMounterManager.attrMap[name].$props"/>
 * </template>
 *
 * 通用用法：
 * - 注册：ptDialogAutoMounterManager.register(【Dialog Vue组件】) ## 可选执行, 注意 Dialog组件这个Function或对象必须保持内存引用，否则会当成不同的组件
 * - 传参数：ptDialogAutoMounterManager.update(【Dialog Vue组件】,【props】，【事件监听函数】)
 * - 打开/关闭：ptDialogAutoMounterManager.toggleOpenState(【Dialog Vue组件】,true/false)
 *
 * 优雅用法：
 * - 传参数：ptDialogAutoMounterManager.update(【Dialog Vue组件】,【props】，【事件监听函数, 不需要resolve, reject, close 函数】)
 * - 打开，在用户submit时resolve，在关闭或点取消时reject：
 *     ptDialogAutoMounterManager.openAsPromise(【Dialog Vue组件】)
 *      .then((【Dialog emit resolve 事件的内容】) {} )
 *      .catch((【Dialog emit reject 或 close 事件的内容】) {} )
 *
 * [可选] 和某个View的生命周期绑定 （某个View Model 销毁时，在本View Model active 期间打开的 Dialog 会跟着一起 注销）:
 * 即：用户按浏览器后退按钮时，Dialog 忘记销毁的bug
 * - ptDialogAutoMounterManager.bindAutoUnregisterToLifecycle(vm) // 放在 created hook里
 *
 */
import { DialogAutoMounterManager } from '@patsnap-biz/dialog';

const ptDialogAutoMounterManager = new DialogAutoMounterManager();

export default ptDialogAutoMounterManager;

export { DialogAutoMounterManager };
